import { render, staticRenderFns } from "./BlocoDadosCertificacao.vue?vue&type=template&id=09e1f5d0&scoped=true&lang=pug"
import script from "./BlocoDadosCertificacao.vue?vue&type=script&lang=js"
export * from "./BlocoDadosCertificacao.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosCertificacao.vue?vue&type=style&index=0&id=09e1f5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e1f5d0",
  null
  
)

export default component.exports